import { Component } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslatePipe } from '@ngx-translate/core';
import { EUserTheme } from '../../../state/user/user.interface';
import { ThemeService } from './theme.service';

@Component({
  imports: [MatSlideToggleModule, TranslatePipe],
  selector: 'app-theme-switcher',
  standalone: true,
  styleUrls: ['./theme-switcher.component.scss'],
  templateUrl: './theme-switcher.component.html',
})
export class ThemeSwitcherComponent {
  protected readonly EUserTheme = EUserTheme;

  public get activeTheme(): EUserTheme {
    return this.themeService.activeTheme;
  }

  constructor(public readonly themeService: ThemeService) {}

  public toggleTheme(): void {
    this.themeService.toggleTheme();
  }
}
